import _ from '@lodash';
import { useState, createContext, useContext, useEffect } from 'react';

import AspectEditService from 'app/admin/aspect/service/AspectEditService';

export const TaskManagerContext = createContext(null);

export const useTaskManager = () => {
    return useContext(TaskManagerContext);
};

export default function TaskManagerProvider(props) {
    const [aspectId, setAspectId] = useState(null);
    const [aspectData, setAspectData] = useState(null);
    const [aspectOutputOptionList, setAspectOutputOptionList] = useState([]);

    // useEffect(() => {
    //     console.log('Get data for aspect id: ' + aspectId);

    //     if (aspectId !== null) {
    //         AspectEditService.getData(aspectId).then(data => {
    //             setAspectData(data);
    //         }).catch(e => { console.log(e); setAspectData(null); });
    //     } else {
    //         setAspectData(null);
    //     }
    // }, [aspectId]);

    // useEffect(() => {
    //     if (aspectData && aspectData.input_attributes)
    //         resolveAspectOutputOptionList();
    // }, [aspectData]);

    // useEffect(() => {
    //     console.log('Get data for aspect id: ' + aspectId);
    //     console.log(aspectOutputOptionList);
    // }, [aspectOutputOptionList]);

    const resolveAspectOutputOptionList = () => {
        let arr = [];
        for (let i = 0; i < aspectData.output_attributes.length; i += 1)
            arr.push({ label: aspectData.output_attributes[i].name, value: aspectData.output_attributes[i].name });
        return arr;
    };

    const getAspectOutputOptionList = () => {
        console.log(this);
        console.log('getAspectOutputOptionList for aspect: ' + aspectId);
        console.log(aspectOutputOptionList);
        return new Promise(resolve => { resolve(aspectOutputOptionList); });
    };

    const value = {
        aspectId,
        setAspectId,
        aspectData,
        setAspectData,
        getAspectOutputOptionList
    };

    return <TaskManagerContext.Provider value={value}>{props.children}</TaskManagerContext.Provider>;
}